
import { Component, Vue } from 'vue-property-decorator'
import { AppModule } from '@/store/module'

import InfoBlock from './components/InfoBlock.vue'
import CommentBlock from './components/CommentBlock.vue'

@Component({
  components: {
    InfoBlock,
    CommentBlock,
  },
})
export default class Member extends Vue {
  breadcrumbItems = [
    { label: '首頁', to: '/' },
    { label: '最新功能' },
    { label: '新點餐界面' }
  ]

  get isH5() {
    return AppModule.isH5
  }

  get images() {
    return [
      /*
      'https://spics.inctrip.com/b261c7fc4681ec1bd3bdb08119393f79.png',
      'https://spics.inctrip.com/087e91c42a6b39b69f6e7b24c1b6887c.png',
      'https://spics.inctrip.com/dcfef7d129d4b3731f276201fc0eb1ba.png',
      'https://spics.inctrip.com/87ff24ca7dfa8fd3a808774c7204881c.png',
      'https://spics.inctrip.com/d8e2ef6675c060a661e0ed2427b40ae7.png',
      'https://spics.inctrip.com/69183368e9765f01938a8ebb5983ad08.png'
      */
      'https://spics.inctrip.com/afda84aafbbac16a442fa23dc407384b.png',
      'https://spics.inctrip.com/b89c19f49e9b5fa2256c3d45a5b8aee5.png',
      'https://spics.inctrip.com/45005a710a7eaeda211ab399de24d4bb.png',
      'https://spics.inctrip.com/c44174dd2d79f5ea5384feb054e26baf.png',
      'https://spics.inctrip.com/0361396096895694caa140afe8046858.png',
      'https://spics.inctrip.com/286140935aa00b02050607d0fec538cb.png'
    ]
  }
}
